/**
 * Clean a stack trace by removing webcontainer URL parts and showing only relative paths
 * @param stack The original stack trace string
 * @returns A cleaned stack trace with simplified paths
 */
export const cleanStackTrace = (stack: string | undefined): string => {
  if (!stack) {
    return '';
  }

  // Split by newlines to process each stack frame
  const processedLines = stack.split('\n').map((line) => {
    // Match the webcontainer URL pattern
    const match = line.match(/https:\/\/[^/]+\/(.+?)(\)|\s|$)/);

    if (match) {
      // Extract the relative path and the rest of the line
      const relativePath = match[1];

      // Create a cleaner representation with just the path
      const linePrefix = line.substring(0, line.indexOf('(') !== -1 ? line.indexOf('(') : line.indexOf('https://'));
      return `${linePrefix}(/${relativePath}`;
    }

    return line;
  });
  // Take only the first 4 lines
  const truncatedLines = processedLines.slice(0, 4);

  return truncatedLines.join('\n');
};
